<template>
    <div class="portlet light borderless">
        <div class="portlet-title">
            <div class="caption">
                <span class="caption-subject bold uppercase">
                    {{ item.name }} - <small> new value </small>
                </span>
            </div>
            <div class="actions">
                <button class="btn btn-md btn-outline dark" @click="goBack">
                    <i class="glyphicon glyphicon-arrow-left"></i> Back
                </button>
            </div>
        </div>
        <div class="portlet-body">
            <div class="row">
                <div class="col-md-6 col-md-offset-2">
                    <div class="form-horizontal">
                        <div class="form-group" :class="{'has-error': form.errors.has('valid_from')}">
                            <label class="col-md-4 control-label">Valid from</label>
                            <div class="col-md-8">
                                <input type="date" class="form-control" v-model="form.valid_from">
                                <span class="help-block" v-if="form.errors.has('valid_from')" v-text="form.errors.get('valid_from')"></span>
                            </div>
                        </div>
                        <div class="form-group" :class="{'has-error': form.errors.has('country_code')}">
                            <label class="col-md-4 control-label">Country</label>
                            <div class="col-md-4">
                                <select class="form-control" v-model="form.country_code">
                                    <option value>All</option>
                                    <option value="ro">RO</option>
                                    <option value="ca">CA</option>
                                    <option value="us">US</option>
                                    <option value="mx">MX</option>
                                </select>
                            </div>
                        </div>

                        <div v-if="item.is_single_valued">
                            <div class="form-group" v-for="field in item.fields" :class="{'has-error': form.errors.has(field.slug)}">
                                <label class="col-md-4 control-label" v-text="field.name"></label>
                                <div class="col-md-8">
                                    <input :type="field.type" class="form-control" v-model="form['value_data'][field.slug]">
                                    <span class="help-block" v-if="form.errors.has(field.slug)" v-text="form.errors.get(field.slug)"></span>
                                </div>
                            </div>

                            <button class="btn btn-md btn-outline blue pull-right" @click="save()">
                                <i class="glyphicon glyphicon-ok"></i> Save
                            </button>
                        </div>
                    </div>
                </div>

                <div class="col-md-12" v-if="!item.is_single_valued">

                    <hr>

                    <div class="row">
                        <div class="col-md-4">
                            <h4 class="pull-left">Data</h4>
                        </div>
                        <div class="col-md-4">
                            <input type="text" class="form-control pull-left" v-model="searchTerm" placeholder="Filter values...  ">
                        </div>
                        <div class="col-md-4">
                            <button class="btn btn-md btn-outline dark pull-right" @click="addValue">
                                <i class="glyphicon glyphicon-plus"></i> Add value
                            </button>
                            <button class="btn btn-md btn-outline dark pull-right" @click="$modal.show('import-values-modal')">
                                <i class="glyphicon glyphicon-import"></i> Import values
                            </button>
                        </div>
                    </div>

                    <hr>

                    <div class="field-line">
                        <div class="row">
                            <div class="col-md-6 text-left">
                                <strong>{{ form.value_data.length }}</strong> total items
                                <br>
                                <span v-if="form.value_data.length !== totalFilteredItems">
                                    <strong>{{ totalFilteredItems }}</strong> filtered items
                                </span>
                            </div>

                            <div class="col-md-6 text-right">
                                <button class="btn btn-md btn-outline blue" @click="save()">
                                    <i class="glyphicon glyphicon-ok"></i> Save
                                </button>
                            </div>

                        </div>

                        <hr>

                        <div class="row" v-for="(data, index) in slicedValueData">
                            <div class="col-md-12" v-if="index != 0 && item.fields.length > 5">
                                <hr class="margin-bottom-10 margin-top-10 margin-left-20 margin-right-20">
                            </div>
                            <div class="col-md-11">
                                <div class="row">
                                    <div v-bind:class="item.fields.length == 1 ? 'col-md-12' : (item.fields.length == 2 ? 'col-md-6' : (item.fields.length == 3 ? 'col-md-4' : (item.fields.length == 4 ? 'col-md-3' : 'col-auto')))" v-for="(field) in item.fields">
                                        <div class="form-group">
                                            <label class="control-label" v-text="field.name"></label>
                                            <input :type="field.type" class="form-control" placeholder="Field name" v-model="form.value_data[index][field.slug]">
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="col-md-1">
                                <button class="btn btn-xs btn-outline dark" style="margin-top: 30px;" @click="removeValue(index)">
                                    <i class="glyphicon glyphicon-minus"></i>
                                </button>
                            </div>
                        </div>

                        <div class="more-items" v-if="totalFilteredItems > itemsDisplayed">
                            {{ totalFilteredItems - itemsDisplayed }} more items... <a href="#" @click.prevent="itemsDisplayed += limit">show more</a>
                        </div>
                    </div>

                    <hr>

                    <button class="btn btn-md btn-outline blue" @click="save()">
                        <i class="glyphicon glyphicon-ok"></i> Save
                    </button>

                    <modal name="import-values-modal" :title="'Import values'">
                        <form class="form-horizontal margin-top-40">
                            <div class="form-group">
                                <label for="import" class="col-md-4 control-label">CSV file to import</label>
                                <div class="col-md-8">
                                    <input type="file" ref="importFile" id="import">
                                    <p class="help-block"> some help text here. </p>
                                </div>
                            </div>
                        </form>

                        <div slot="actions">
                            <button class="btn btn-outline dark" @click="importFile">Import</button>
                            <button class="btn btn-outline">Cancel</button>
                        </div>
                    </modal>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
    import Form from 'services/form/Form'
    import Modal from 'components/global/Modal'

    export default {
        name: "config-value-add-edit",

        components: {
            Modal
        },

        props: {
            item: {
                type: Object,
                required: true
            },
            value: {
                default: null
            }
        },

        data() {
            return {
                form: new Form(),
                searchTerm: null,
                limit: 100,
                itemsDisplayed: 100,
            }
        },

        computed: {
            saveUrl() {
                return this.value
                    ? Sincron.routes.route('config-value.update', {config: this.item.id, configValue: this.value.id})
                    : Sincron.routes.route('config-value.store', {config: this.item.id})
            },

            slicedValueData() {
                if (this.searchTerm === null || this.searchTerm.length < 3) {
                    return _.slice(this.filteredValueData, 0, this.itemsDisplayed)
                }

                return this.filteredValueData
            },

            filteredValueData() {
                if (this.searchTerm === null || this.searchTerm.length < 3) {
                    return this.form.value_data
                }

                let searchTerm = _.toLower(this.searchTerm)

                return _.pickBy(this.form.value_data, (data) => {
                    let includes = false

                    _.forEach(this.item.fields, (field) => {
                        let value = _.toLower(data[field.slug])
                        if (_.includes(value, searchTerm)) {
                            includes = true
                        }
                    })

                    return includes
                })
            },

            totalFilteredItems() {
                if (_.isArray(this.filteredValueData)) {
                    return this.filteredValueData.length
                }

                return Object.keys(this.filteredValueData).length
            }
        },

        methods: {
            defaultFormObject() {
                let data = {}

                _.each(this.item.fields, (field) => {
                    data[field.slug] = null
                })

                if (!this.item.is_single_valued) {
                    data = [data];
                }

                return {
                    valid_from: null,
                    country_code: null,
                    value_data: data
                }
            },

            valueFormObject(value) {
                return {
                    valid_from: value.valid_from,
                    country_code: value.country_code,
                    value_data: value.data
                }
            },

            setForm(value) {
                if (value) {
                    this.form = new Form(this.valueFormObject(value))
                } else {
                    this.form = new Form(this.defaultFormObject())
                }
            },

            async save() {
                try {
                    let response = await this.form.post(this.saveUrl)

                    if (!this.value) {
                        this.$emit('value-created', response.value)
                    }
                    this.$toaster.success(response.message)
                } catch (error) {
                    this.$toaster.error(error.message)
                }
            },

            addValue() {
                let data = {}

                _.each(this.item.fields, (field) => {
                    data[field.slug] = null
                })

                this.form.value_data.push(data)
            },

            removeValue(index) {
                this.form.value_data.splice(index, 1)
            },

            async importFile() {
                let file = this.$refs.importFile.files[0];

                if (!file) {
                    return
                }

                let formData = new FormData()
                formData.append('file', file)

                try {
                    const importUrl = Sincron.routes.route('config-value.import', {config: this.item.id, configValue: _.get(this.value, 'id', null)})

                    let {data} = await axios.post(importUrl, formData, {
                        headers: {
                            'Content-Type': 'multipart/form-data'
                        }
                    })

                    this.form.value_data = data.values

                    this.$modal.hide('import-values-modal')
                } catch (e) {
                    console.log(e)
                }


            },

            goBack() {
                this.$emit('view-mode')
            }
        },

        beforeMount() {
            this.setForm(this.value);
        },

    }
</script>
